import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";
import about1 from "../../assets/Images/About/KGM-87.jpg";

export default function ImageBanner2() {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      {/* Main Content Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
            transition: "all 0.5s ease",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={about1}
              alt="Profile 2"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: isHovered ? "scale(1.05)" : "scale(1)",
                filter: isHovered ? "brightness(1.05)" : "brightness(1)",
                objectPosition: "left 20%",
              }}
            />
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
